import { CartaoContasService } from '../../../../shared/components/cartao-gestante/cartao-contas.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { EnfermeiroService } from '../../enfermeiro.service';
import { AlertsService } from 'app/shared/alerts.service';
import { CartaoGestante, ConsultaPaciente, ExameLaboratorio, Paciente } from 'app/core/interfaces/pacient-info.interface';
import { FormGroup, FormControl } from '@angular/forms';
import { ModalsService } from 'app/shared/modals.service';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { MatDialog } from '@angular/material';
import { ModalAdicionarExameComponent } from '../../components/modal-adicionar-exame/modal-adicionar-exame.component';
import { Events } from 'app/core/events';
import { EnfermeiroEncerrarCartaoComponent } from '../enfermeiro-encerrar-cartao/enfermeiro-encerrar-cartao.component';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { AuthService } from 'app/core/auth/auth.service';
import { logger } from '../../../../core/utils/console';
import { LaboratorioArquivoFlowService } from 'app/shared/laboratorio-arquivo-flow.service';

@Component({
    selector: 'app-enfermeiro-alterar-cartao-gestante',
    templateUrl: './enfermeiro-alterar-cartao-gestante.component.html',
    styleUrls: ['./enfermeiro-alterar-cartao-gestante.component.scss']
})
export class EnfermeiroAlterarCartaoGestanteComponent implements OnInit, AfterViewInit {

  fuseConfig: any;

  enfermeiro: Enfermeiro;
  cartao_id: string;
  paciente_id: string;
  oldPage: number;

  examesLabArr = ['ABO/Rh', 'Hepatite B', 'Hepatite C', 'Plaquetas', 'HT/HB', 'CMV IgG', 'CMV IgM', 'TSH', 'Glicose em Jejum', 'TTOG (GTT)', 'HIV', 'VDRL', 'HBsAG', 'Coombs Ind', 'Toxo IgM', 'Toxo IgG', 'Rubéola IgM', 'Rubéola IgG', 'Urina I', 'Urocultura', 'Parasitológico', 'Cultura Streptococcus', 'Parasitológico', 'Outros'];

  paciente: Paciente;

  cartao_gestante_obj: CartaoGestante;

  consultas_cartao: ConsultaPaciente[] = [];

  loading = true;
  showCard = false;

  dados_graficos_prontos = false;
  dados_dos_graficos: any = [];

  @ViewChild('cartao_gestante_componente') componente_cartao_gestante: any;

  form_info_cartao: FormGroup = new FormGroup({
      data_concepcao: new FormControl(''),
      previsao_parto_dum: new FormControl(''),
      previsao_parto_ultrassom: new FormControl(''),
  });
  formulario_cartao_gestante: FormGroup;

  formulario_cartao_alterado: boolean;

  constructor(
    private router: Router, 
    private enfermeiroService: EnfermeiroService, 
    private snackService: AlertsService, 
    private modalService: ModalsService, 
    private matDialog: MatDialog,
    private events:Events,
    private _apigestacard: APIGestaCardService,  // apagar
    private _authService: AuthService,
    public cartaoService: CartaoContasService,
    private _laboratorioArquivoFlow: LaboratorioArquivoFlowService
  ) {

    try {

      const navigation = this.router.getCurrentNavigation();

      if (navigation && navigation.extras && navigation.extras.state) {
        const state = navigation.extras.state;
        if (state.cartao_id && state.paciente_id) {
          this.cartao_id = state.cartao_id;
          this.paciente_id = state.paciente_id;
          this.oldPage = state.oldPage || 1;
        } else {
          this.router.navigateByUrl('/enfermeiro');
        }
      } else {
        this.router.navigateByUrl('/enfermeiro');
      }

    } catch(err) {

      logger.log('EnfermeiroAlterarCartaoGestanteComponent -> constructor -> err', err);
      this.router.navigateByUrl('/enfermeiro');

    }

  }

  AddModalExame() {

    const dialogRef = this.matDialog.open(ModalAdicionarExameComponent, {
      width: '300px'
    });

    dialogRef.afterClosed().subscribe((res) => {
      
      this.addModalExameOnload(res);

    });
  }

  addModalExameOnload(res) {

    switch (res) {
      case 'clinico':
          this.InserirClinico();
          break;
      case 'laboratorial':
          this.InserirLab();
          break;
      case 'ultrassom':
          this.InserirUSG();
          break;
      case 'outro':
          this.InserirOutro();
          break;
      default:
          break;
    }

  }

  /** @todo IMPLEMENTAR O MODAL QUE IRÁ ALTERAR O VALOR  */
  SubindoEdicaoCelularExames(event) {

    const trimestre_clicado = event.trimestre;

    if (event.exame == null && event.anotherField == 'data') { // Edição de data

      const dataTrimestre = this.cartao_gestante_obj.exames.laboratorio[0].datas[`data${trimestre_clicado}`];

      this.modalService.AbrirModalDataTrimestre(dataTrimestre).subscribe((res: any) => {

        if (res == null || res == undefined) { return; }

        const aux = res ? res : '';

        this._apigestacard.AlterarTrimestreExameLab(this.cartao_id, trimestre_clicado, aux, this.cartao_gestante_obj.exames).then((result) => {

          this.cartao_gestante_obj.exames.laboratorio = result;

          this.events.publish('ChangeDataTrimestre');

          this.snackService.SnackMessage('Data do trimestre alterada!');

        }).catch((err) => {

          logger.log('EnfermeiroAlterarCartaoGestanteComponent -> AlterarTrimestreExameLab -> err', err);

        });

      });

    } else {

      const data_limite_aux = event.exame[`data_limite_tri${trimestre_clicado}`];
      const data_limite: Date = !data_limite_aux || data_limite_aux == '' ? null : new Date(data_limite_aux.seconds * 1000);
      const hoje = new Date();

      const oldValue = event.exame.datas[`res${trimestre_clicado}`];

      // ** FUNCAO DE CHECAGEM DE DATA LIMITE DESABILITADA
      this.modalService.AbrirModalResultadoExame(event.exame.name, oldValue).subscribe((res: any) => {
        const valor = res ? res : '';

        var laboratoriais = this.cartao_gestante_obj.exames.laboratorio

        var aux = laboratoriais.filter(item => item.name == event.exame.name)
        var exame_a_editar = aux[0]

        var index = laboratoriais.indexOf(exame_a_editar)

        if (event.allTrimestre) {
          exame_a_editar.datas[`res1`] = valor
          exame_a_editar.datas[`res2`] = valor
          exame_a_editar.datas[`res3`] = valor

          if (!valor) {
            exame_a_editar.arquivo_res1 = null
            exame_a_editar.arquivo_res2 = null
            exame_a_editar.arquivo_res3 = null
            exame_a_editar.datas[`data1`] = null
            exame_a_editar.datas[`data2`] = null
            exame_a_editar.datas[`data3`] = null
          }
        } else {
          exame_a_editar.datas[`res${event.trimestre}`] = valor

          if (!valor) {
            if (event.trimestre == 1) {
              exame_a_editar.arquivo_res1 = null
              exame_a_editar.datas[`data1`] = null
            }

            if (event.trimestre == 2) {
              exame_a_editar.arquivo_res2 = null
              exame_a_editar.datas[`data2`] = null
            }

            if (event.trimestre == 3) {
              exame_a_editar.arquivo_res3 = null
              exame_a_editar.datas[`data3`] = null
            }
          }
        }

        laboratoriais[index] = exame_a_editar

        this.cartao_gestante_obj.exames.laboratorio = laboratoriais

        this.formulario_cartao_alterado = true;

      });

    }

  }

  AtualizarExamesLab(event) {
    this.cartao_gestante_obj.exames.laboratorio = event.examesNew;
    
    this.formulario_cartao_alterado = true;
  }


  Voltar() {
    const navigationExtras: NavigationExtras = {
      state: {
        page: this.oldPage,
      }
    };

    this.router.navigate(['/enfermeiro'], navigationExtras);
  }

  EncerrarCartao() {

    const dialogEncerrar = this.matDialog.open(EnfermeiroEncerrarCartaoComponent, { 
      maxWidth: '80%',
      data: { 
        paciente: this.paciente, 
        cartao: this.cartao_gestante_obj
      }
    });

    dialogEncerrar.afterClosed().subscribe((formData?) => {

      if (formData !== undefined) {

        this.enfermeiroService.RegistrarEncerramento(this.cartao_id, formData).finally(() => {

          this.snackService.SnackMessage('Cartão encerrado com sucesso!');
          this.BuscarDadosCartao();

        });

      }

    });

  }

  initData() {
    this.enfermeiroService.GetPacientePorId(this.paciente_id).then((res) => {
      
      this.paciente = res;
        
    }).catch((err) => {

      logger.log('EnfermeiroAlterarCartaoGestanteComponent -> initData -> err', err);

    });

    this.enfermeiroService.GetUserData().subscribe((res) => {
      this.enfermeiro = res;
    });

  }

  ngOnInit() {

    this.initData();

  }

  ngAfterViewInit() {

    // Buscando o formulário do componente cartão gestante
    this.formulario_cartao_gestante = this.componente_cartao_gestante.cartao_gestante;

    if (this.paciente_id && this.cartao_id) {
      this.BuscarDadosCartao();
    }

    this.events.unsubscribe('CarregarExames'); // EXAMES LABORATORIAIS
    this.events.subscribe('CarregarExames', () => {

      const aux = this.cartao_gestante_obj.sobre_a_gestacao;
      const DppUS = this.cartaoService.PrevisaoUltrassom(aux.us1, aux.us_semanas, aux.us_dias);

      const trimestres = this.cartaoService.CalcularTrimestres(DppUS);

      const vetor_exames = this.examesLabArr.map((item) => {
        return {
          name: item,
          data_limite_tri1: '',
          data_limite_tri2: '',
          data_limite_tri3: '',
          arquivo_res1: null,
          arquivo_res2: null,
          arquivo_res3: null,
          datas: {
              data1: trimestres[0] ? trimestres[0] : '',
              data2: trimestres[1] ? trimestres[1] : '',
              data3: trimestres[2] ? trimestres[2] : '',
              res1: '',
              res2: '',
              res3: '',
          }
        };
      });

      this._apigestacard.InserirLab(this.cartao_id, vetor_exames, this.cartao_gestante_obj.exames).then((result) => {
        
        this.InserirExameRefresh();

      }).catch((err) => {

        logger.log('EnfermeiroAlterarCartaoGestanteComponent -> InserirLab -> err', err);

      });

    }); // end event CarregarExames
    
    this.events.unsubscribe('ExameLaboratorialIncluirPDF'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameLaboratorialIncluirPDF', data => {
      this.AnalisarPDFExamesLab(data);
    });

    this.events.unsubscribe('UtilizarArquivoLaboratorial'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('UtilizarArquivoLaboratorial', data => {
      this.UtilizarArquivoLabExistente(data);
    });

    this.events.unsubscribe('AnalisarArquivoLaboratorial');
    this.events.subscribe('AnalisarArquivoLaboratorial', data => {
      this.AnalisarArquivoLabExistente(data);
    });

    this.events.unsubscribe('ExameUltrassonografiaIncluir'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameUltrassonografiaIncluir', data => {
      this.InserirUSG();
    });

    this.events.unsubscribe('ExameUltrassonografiaRemover');
    this.events.subscribe('ExameUltrassonografiaRemover', data => {
      this.RemoverExameUSG(data);
    });
    
    this.events.unsubscribe('ExameUltrassonografiaIncluirPDF'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameUltrassonografiaIncluirPDF', data => {
      this.AlterarListaUSG();
    });

    this.events.unsubscribe('UtilizarArquivoUSG'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('UtilizarArquivoUSG', data => {
      this.UtilizarArquivoUSGExistente(data);
    });

    this.events.unsubscribe('AnalisarArquivoUSG');
    this.events.subscribe('AnalisarArquivoUSG', data => {
      this.AnalisarArquivoUSGExistente(data);
    });

    this.events.unsubscribe('ExameOutrosIncluir'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameOutrosIncluir', data => {
      
      this.InserirOutro();

    });

    this.events.unsubscribe('ExameClinicoIncluir'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameClinicoIncluir', data => {
      
      this.InserirClinico();

    });

    this.events.unsubscribe('ExameClinicoEditar'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameClinicoEditar', data => {
      
      this.EditarClinico(data);

    });

    this.events.unsubscribe('ExameClinicoAddObservacao'); // Evitando Loop de subscribe ao sair e voltar no componente
    this.events.subscribe('ExameClinicoAddObservacao', data => {
      
      this.ExameClinicoAddObservacao(data);

    });

    this.formulario_cartao_alterado = false;

  }

  RecarregarPaginaDoCartao() {

    const navigationExtras: NavigationExtras = {
      state: {
        cartao_id: this.cartao_id,
        paciente_id: this.paciente_id,
      }
    };

    this.router.navigate(['/enfermeiro-alterar-cartao-gestante'], navigationExtras);

  }

  InserirClinico() {

    const sobre_a_gestacao = this.cartao_gestante_obj.sobre_a_gestacao;

    this.cartaoService.AbrirModalClinicos(sobre_a_gestacao.dum, sobre_a_gestacao.us1, sobre_a_gestacao.us_semanas, sobre_a_gestacao.us_dias).subscribe((res) => {

        if (res) {

          this._apigestacard.InserirExameClinico(this.cartao_id, res, this.cartao_gestante_obj.exames).then((result) => {

            this.InserirExameRefresh();
            
          }).catch((err) => {

              logger.log('EnfermeiroAlterarCartaoGestanteComponent -> InserirClinico -> err', err);

          });

        }

    });
  }

  /**
   * 
   * @param data Valores atuais do exame clinico que serão modificados
   */
  EditarClinico(data) {

    const sobre_a_gestacao = data;
    
    this.cartaoService.AbrirModalClinicosEditar(data).subscribe((res) => {
      
      if (res) {
        this._apigestacard.EditarExameClinico(this.cartao_id, data, res, this.cartao_gestante_obj.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('EnfermeiroAlterarCartaoGestanteComponent -> InserirClinico -> err', err);
            
        });
      }
    });

  }

  ExameClinicoAddObservacao(data) {

    this.cartaoService.AbrirModalClinicosEditarObservacao(data).subscribe((res) => {
      
      if (res) {
        let newData = data;
        
        newData.obs = res.obs; // Atualizando a observação do exame clinico com a nova observação adicionada

        this._apigestacard.EditarExameClinico(this.cartao_id, data, newData, this.cartao_gestante_obj.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('MedicoAlterarCartaoGestanteComponent -> InserirClinico -> err', err);
            
        });
      }

    });

  }
  
  async AnalisarPDFExamesLab(data: { callback: (exames: ExameLaboratorio[]) => void }) {    
    try {
      let dum, cartao_id, exames_lab;
      
      if (this.cartao_gestante_obj.sobre_a_gestacao && this.cartao_gestante_obj.sobre_a_gestacao.dum) dum = this.cartao_gestante_obj.sobre_a_gestacao.dum;
      if (this.cartao_gestante_obj.id) cartao_id = this.cartao_gestante_obj.id;
      if (this.cartao_gestante_obj.exames.laboratorio) exames_lab = this.cartao_gestante_obj.exames.laboratorio;

      if (!dum || !cartao_id || !exames_lab) {
        logger.error('Dados insuficientes para analisar PDF de exames laboratoriais.');
        return;
      }

      const result = await this.modalService.AnalisarExamesPorPDF(exames_lab, dum, cartao_id);
      
      if (!result) return;

      data.callback(result.examesLaboratorios);
      
      this.formulario_cartao_alterado = true;
      this.AtualizarExamesLab({ examesNew: result.examesLaboratorios });

      this.enfermeiroService.MudarStatusArquivo(result.arquivoId, 'utilizado');

      return result.examesLaboratorios;
    } catch (error) {
      logger.error('Erro ao analisar PDF de exames:', error);
    }
  }

  async UtilizarArquivoLabExistente(data: { arquivoId: string, trimestre: number, callback: (exames: ExameLaboratorio[]) => void, onFinish?: () => void }) {
    return this.processarArquivoLabExistente(data, false);
  }

  async AnalisarArquivoLabExistente(data: { arquivoId: string, trimestre: number, callback: (exames: ExameLaboratorio[]) => void, onFinish?: () => void }) {
    return this.processarArquivoLabExistente(data, true);
  }

  private async processarArquivoLabExistente(
    data: { arquivoId: string, trimestre: number, callback: (exames: ExameLaboratorio[]) => void, onFinish?: () => void },
    reanalisar: boolean
  ) {
    try {
      const exames_lab = this.cartao_gestante_obj.exames.laboratorio;
      const dum = this.cartao_gestante_obj.sobre_a_gestacao && this.cartao_gestante_obj.sobre_a_gestacao.dum
        ? this.cartao_gestante_obj.sobre_a_gestacao.dum
        : undefined;
      const cartao_id = this.cartao_gestante_obj.id;

      const result = await this._laboratorioArquivoFlow.processarArquivoExistente({
        arquivoId: data.arquivoId,
        trimestre: data.trimestre,
        examesLab: exames_lab,
        dum,
        cartaoId: cartao_id,
        reanalisar
      });

      if (!result) { data.onFinish && data.onFinish(); return; }

      data.callback(result.examesLaboratorios);
      this.formulario_cartao_alterado = true;
      this.AtualizarExamesLab({ examesNew: result.examesLaboratorios });

      if (this.cartao_gestante_obj.arquivos_analisados) {
        const arq = this.cartao_gestante_obj.arquivos_analisados.find(a => a.id === data.arquivoId);
        if (arq) arq.status = 'utilizado';
      }

      data.onFinish && data.onFinish();
      this.enfermeiroService.MudarStatusArquivo(data.arquivoId, 'utilizado');
    } catch (error) {
      logger.error(
        reanalisar
          ? 'Erro ao analisar arquivo laboratorial existente:'
          : 'Erro ao utilizar arquivo laboratorial existente:',
        error
      );
      data.onFinish && data.onFinish();
    }
  }

  InserirLab() {

    this.cartaoService.AbrirModalLab(this.cartao_gestante_obj.exames.laboratorio).subscribe((res) => {
      
      if (res) {
        const vetor_exames = res.exames_selecionados.map((item) => {
          return {
            name: item,
            data_limite_tri1: res.trimestre == 1 ? res.data_limite_edicao : '',
            data_limite_tri2: res.trimestre == 2 ? res.data_limite_edicao : '',
            data_limite_tri3: res.trimestre == 3 ? res.data_limite_edicao : '',
            arquivo_res1: null,
            arquivo_res2: null,
            arquivo_res3: null,
            datas: {
                data1: res.trimestre == '1' ? res.data : '',
                data2: res.trimestre == '2' ? res.data : '',
                data3: res.trimestre == '3' ? res.data : '',
                res1: '',
                res2: '',
                res3: '',
            }
          };
        });

        this._apigestacard.InserirLab(this.cartao_id, vetor_exames, this.cartao_gestante_obj.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('EnfermeiroAlterarCartaoGestanteComponent -> InserirLab -> err', err);

        });

      }

    });

  }

  RemoverExameLab(event) {

    const exame = event.exame;

    this.modalService.AbrirModalDeConfirmacao('Remover Exame Laboratorial', `Tem certeza que deseja remover o exame ${exame.name}? Essa ação não poderá ser desfeita.`).subscribe((res) => {
      if (res) {
        this._apigestacard.RemoverExameLaboratorios(this.cartao_id, exame, this.cartao_gestante_obj.exames).then((result) => {
          this.cartao_gestante_obj.exames = result;
        }).catch((err) => {
          logger.log('MedicoAlterarCartaoGestanteComponent -> RemoverExameLab -> err', err);
        });
      }
    });
    
  }

  RemoverExameUSG(event: { exame: any, callback?: (ultrasom: any[]) => void }) {
    const exame = event.exame;

    this.modalService.AbrirModalDeConfirmacao('Remover Ultrassonografia', 'Tem certeza que deseja remover esta ultrassonografia? Essa ação não poderá ser desfeita.').subscribe((res) => {
      if (!res) return;

      const ultrasomAtual = this.cartao_gestante_obj.exames.ultrasom || [];
      const ultrasomAtualizado = ultrasomAtual.filter(item => item !== exame);

      this._apigestacard.AlterarUSG(this.cartao_id, ultrasomAtualizado, this.cartao_gestante_obj.exames).then((result) => {
        this.cartao_gestante_obj.exames = result;
        if (event.callback) event.callback(result.ultrasom || []);
        this.InserirExameRefresh();
      }).catch((err) => {
        logger.log('EnfermeiroAlterarCartaoGestanteComponent -> RemoverExameUSG -> err', err);
      });
    });
  }

  async AlterarListaUSG() {
    const result = await this.modalService.AnalisarUltrasonografiaPorPDF(this.cartao_gestante_obj.exames.ultrasom, this.cartao_id);
    
    if (!result) return;

    this.formulario_cartao_alterado = true;
    this.cartao_gestante_obj.exames.ultrasom = result.ultrasonografias;

    this._apigestacard.AlterarUSG(this.cartao_id, result.ultrasonografias, this.cartao_gestante_obj.exames).then(() => {
      this.InserirExameRefresh();

      this.enfermeiroService.MudarStatusArquivo(result.arquivoId, 'utilizado');
    }).catch((err) => {
      logger.log('MedicoAlterarCartaoGestanteComponent -> AlterarListaUSG -> err', err);
    });
  }

  async UtilizarArquivoUSGExistente(data: { arquivoId: string, callback: (ultrasom: any[]) => void, onFinish?: () => void }) {
    try {
      const arquivo = await this._apigestacard.BuscarArquivoPDF(data.arquivoId);
      if (!arquivo) {
        logger.error('Arquivo USG não encontrado.');
        data.onFinish && data.onFinish();
        return;
      }

      let preAnalisedUSG: any[];
      if (arquivo.status === 'pendente') {
        logger.error('Arquivo USG pendente precisa ser analisado antes de utilizar.');
        data.onFinish && data.onFinish();
        return;
      }

      if (!arquivo.resultado) {
        logger.error('Arquivo USG sem resultado.');
        data.onFinish && data.onFinish();
        return;
      }

      preAnalisedUSG = Array.isArray(arquivo.resultado) ? arquivo.resultado : [arquivo.resultado];

      const result = await this.modalService.UtilizarArquivoAnalisadoUSG(
        data.arquivoId,
        preAnalisedUSG,
        this.cartao_gestante_obj.exames.ultrasom,
        this.cartao_id
      );

      if (!result) { data.onFinish && data.onFinish(); return; }

      this.formulario_cartao_alterado = true;
      this.cartao_gestante_obj.exames.ultrasom = result.ultrasonografias;

      if (this.cartao_gestante_obj.arquivos_analisados) {
        const arq = this.cartao_gestante_obj.arquivos_analisados.find(a => a.id === data.arquivoId);
        if (arq) arq.status = 'utilizado';
      }

      data.onFinish && data.onFinish();
      this._apigestacard.AlterarUSG(this.cartao_id, result.ultrasonografias, this.cartao_gestante_obj.exames).then(() => {
        this.InserirExameRefresh();
        data.callback(result.ultrasonografias);
        this.enfermeiroService.MudarStatusArquivo(data.arquivoId, 'utilizado');
      }).catch(err => logger.log('UtilizarArquivoUSGExistente -> err', err));
    } catch (error) {
      logger.error('Erro ao utilizar arquivo USG existente:', error);
      data.onFinish && data.onFinish();
    }
  }

  async AnalisarArquivoUSGExistente(data: { arquivoId: string, callback: (ultrasom: any[]) => void, onFinish?: () => void }) {
    try {
      const arquivo = await this._apigestacard.BuscarArquivoPDF(data.arquivoId);
      if (!arquivo) {
        logger.error('Arquivo USG não encontrado.');
        data.onFinish && data.onFinish();
        return;
      }

      const reanalise = await this._apigestacard.ReAnalisarUltrasom(data.arquivoId);
      const result = await this.modalService.UtilizarArquivoAnalisadoUSG(
        data.arquivoId,
        reanalise.ultrasonografias,
        this.cartao_gestante_obj.exames.ultrasom,
        this.cartao_id
      );

      if (!result) { data.onFinish && data.onFinish(); return; }

      this.formulario_cartao_alterado = true;
      this.cartao_gestante_obj.exames.ultrasom = result.ultrasonografias;

      if (this.cartao_gestante_obj.arquivos_analisados) {
        const arq = this.cartao_gestante_obj.arquivos_analisados.find(a => a.id === data.arquivoId);
        if (arq) arq.status = 'utilizado';
      }

      data.onFinish && data.onFinish();
      this._apigestacard.AlterarUSG(this.cartao_id, result.ultrasonografias, this.cartao_gestante_obj.exames).then(() => {
        this.InserirExameRefresh();
        data.callback(result.ultrasonografias);
        this.enfermeiroService.MudarStatusArquivo(data.arquivoId, 'utilizado');
      }).catch(err => logger.log('AnalisarArquivoUSGExistente -> err', err));
    } catch (error) {
      logger.error('Erro ao analisar arquivo USG existente:', error);
      data.onFinish && data.onFinish();
    }
  }

  InserirUSG() {

    this.cartaoService.AbrirModalUSG().subscribe((res) => {

      if (res) {
        
        this._apigestacard.InserirUSG(this.cartao_id, res, this.cartao_gestante_obj.exames).then(() => {
          
            this.InserirExameRefresh();

        }).catch((err) => {

            logger.log('EnfermeiroAlterarCartaoGestanteComponent -> InserirUSG -> err', err);

        });

      }

    });

  }

  InserirOutro() {

    this.cartaoService.AbrirModalOutros().subscribe((res) => {

      if (res) {

        this._apigestacard.InserirOutros(this.cartao_id, res, this.cartao_gestante_obj.exames).then((result) => {
          
          this.InserirExameRefresh();

        }).catch((err) => {

          logger.log('EnfermeiroAlterarCartaoGestanteComponent -> InserirOutro -> err', err);
          
        });

      }

    });

  }

  InserirExameRefresh() {
    
    if (this.formulario_cartao_alterado) {
      
      this.SalvarAlteracoes(() => {
        
        this.BuscarDadosCartao();

      });

    } else {
      
      this.BuscarDadosCartao();

    }

  }

  async EventoClicado(item) {

    try {
      
      const extras: NavigationExtras = {
        state: {
          paciente: this.paciente,
          consulta: item
        }
      };

      this.router.navigate(['/enfermeiro-nova-consulta'], extras);

    } catch (error) {

    }
    
  }

  BuscarDadosCartao() {
    
    this.loading = true;
    this.dados_dos_graficos = [];

    if (this.cartao_id) this.enfermeiroService.LerUmCartao(this.cartao_id).then((res) => {
      this.cartao_gestante_obj = res;

      // Atualizando os formulários 
      const aux1 = {
        data_concepcao: this.TimeStampToDate(this.cartao_gestante_obj.data_concepcao),
        previsao_parto_dum: this.TimeStampToDate(this.cartao_gestante_obj.previsao_parto_dum),
        previsao_parto_ultrassom: this.TimeStampToDate(this.cartao_gestante_obj.previsao_parto_ultrassom)
      };

      this.form_info_cartao.setValue(aux1);

      this.setFormValue(this.formulario_cartao_gestante.controls.historico_clinico, this.cartao_gestante_obj.historico_clinico);
      this.setFormValue(this.formulario_cartao_gestante.controls.historico_familiar, this.cartao_gestante_obj.historico_familiar);

      this.setFormValue(this.formulario_cartao_gestante.controls.antecedentes_obstetricos, this.cartao_gestante_obj.antecedentes_obstetricos);
      this.setFormValue(this.formulario_cartao_gestante.controls.sobre_a_gestacao, this.cartao_gestante_obj.sobre_a_gestacao);
      this.setFormValue(this.formulario_cartao_gestante.controls.vacinas, this.cartao_gestante_obj.vacinas);

      if (this.cartao_gestante_obj.exames.hasOwnProperty('clinicos')) {
        this.dados_graficos_prontos = true;
        this.dados_dos_graficos = this.cartao_gestante_obj.exames.clinicos;
      }

      // Tentando forçar a atualização
      this.componente_cartao_gestante.cartao_gestante_obj = this.cartao_gestante_obj;

      this.events.publish('CartaoGestanteDataLoad');

      this.formulario_cartao_alterado = false;

      this.formulario_cartao_gestante.valueChanges.subscribe(res => {

        this.formulario_cartao_alterado = true;

        const formValue = this.formulario_cartao_gestante.value;

        this.cartao_gestante_obj.sobre_a_gestacao = formValue.sobre_a_gestacao;
        this.cartao_gestante_obj.historico_clinico = formValue.historico_clinico;
        this.cartao_gestante_obj.historico_familiar = formValue.historico_familiar;

      });

    }).catch((err) => {

      this.loading = false;

      this.snackService.SnackMessage('Cartão indisponivel para alteração');

      this.router.navigateByUrl('/enfermeiro');

    }).finally(() => {
        this.loading = false;
        this.showCard = true;

    });

  }

  /**
   * Seta o form value a partir do novo layout do form, para nao dar erro com mudanças de estrutura no firebase
   * @param form 
   * @param obj 
   */

  setFormValue(form, obj) {

      const layout = form.value;
      
      for (const z in layout) {
          if (obj.hasOwnProperty(z)) { layout[z] = obj[z]; }
      }

      form.patchValue(layout);

  }

  TimeStampToDate(obj): Date {
      const date = new Date(obj.seconds * 1000);
      return date;
  }

  AtivarDesativarCartao() {

    if (!this.cartao_gestante_obj.ativado) {
      
      this.enfermeiroService.AtivarUmCartao(this.enfermeiro.id, this.paciente.id, this.cartao_id).then(() => {

        this.snackService.SnackMessage('Cartão ativado com sucesso!');
        this.BuscarDadosCartao();

      }).catch((err) => {

        this.snackService.SnackMessage(err);

      });

    } else {

      this.modalService.ConfirmarDesativarCartao().subscribe((res: boolean) => {

        if (res) {

          this.enfermeiroService.DesativarUmCartao(this.cartao_id).finally(() => {

            this.BuscarDadosCartao();

          });

        }

      });

    }

  }

  SalvarAlteracoes(callback?: () => any) {

    const cartao_gestante = this.formulario_cartao_gestante.value;
    const cartao_atualizado = { ...cartao_gestante };

    this.enfermeiroService.AtualizarCartao(this.cartao_id, cartao_atualizado).then(() => {

      this.snackService.SnackMessage('Cartão atualizado com sucesso!');
      
      if (callback) callback()

    }).catch((err) => {

      this.snackService.SnackMessage('Erro ao atualizar o cartão');

    });

  }

  DeletarCartao() {

    this.modalService.AbrirModalDeConfirmacao('Deletar Cartão Gestante', 'Essa ação não poderá ser desfeita, deseja excluir o cartão?').subscribe((res) => {

      if (res) {

        this.enfermeiroService.DeletarCartaoGestante(this.cartao_id).then(() => {

          this.snackService.SnackMessage('Cartão deletado com sucesso!');
          this.router.navigateByUrl('/enfermeiro');

        }).catch((err) => {

          this.snackService.SnackMessage('Erro ao deletar o cartão');

        });

      }

    });

  }

  LogoutCartao() {
    this._authService.Logout();
  }

  get dataCriacao() {

    if (!this.cartao_gestante_obj.criado_em) return ''

    const data = new Date(this.cartao_gestante_obj.criado_em);
    return data;

  }


  imprimindoPDF = false;

  async Imprimir() {
    this.imprimindoPDF = true;
    try {
      const result = await this._apigestacard.GerarPDF(this.cartao_id);
      window.open(result.url, '_system');
    } catch (err) {
      logger.log('EnfermeiroAlterarCartaoGestanteComponent -> Imprimir -> err', err);
      this.snackService.SnackMessage('Erro ao gerar o PDF do cartão');
    } finally {
      this.imprimindoPDF = false;
    }
  }

}
